
import { Component } from '@angular/core';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { ProductAttributeGroupParam } from 'src/app/assabil-kernel/models/entities/control-tables/product-attribute-group-param';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
    selector: 'product-attribute-group-param-lov',
    templateUrl: './product-attribute-group-param-lov.component.html',
    styleUrls: ['./product-attribute-group-param-lov.component.scss']
})


export class ProductAttributeGroupParamLovComponent extends GenericLovComponent {

    code         : string; 
    name         : string; 

    productAttributeGroupParams: ProductAttributeGroupParam[] = [];

    columns = [
        {  prop: 'productAttributeGroupParamCode', name: 'Code'},
        {  prop: 'name', name: 'Nom'}
    ]


//----------------------------------------------------------------------
constructor( 
    public dialogRef: MatDialogRef<ProductAttributeGroupParamLovComponent>,
    protected controlTablesService  : ControlTablesService) {
    super();
    this.entityName = "productAttributeGroupParam";
}
//----------------------------------------------------------------------
    


//----------------------------------------------------------------------
loadData() {
    let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlTablesService.getList(this.entityName, request).then(result => {
        this.productAttributeGroupParams = result;
    })
}
//----------------------------------------------------------------------



//----------------------------------------------------------------------
closeModal(row : ProductAttributeGroupParam){
    this.dialogRef.close(row);
}
//----------------------------------------------------------------------

}
